import { PriorityHighSharp } from "@mui/icons-material";

export const highPriority = (props) => {
  return <PriorityHighSharp {...props} />;
};
